import { IS_TOP } from "./config";

export const bodyEl = document.getElementsByTagName("body")[0];
export const outerWindow = window.top;
export const innerWindow =
  __IFRAME__ && !IS_TOP
    ? parent.document.getElementById("iframe").contentWindow
    : window;

export const overlayEl = document.getElementById("overlay");
export const svgContainerEl = document.getElementById("svg-container");
export const gameEl = document.getElementById("game");
export const boardEl = document.getElementById("board");
export const clipSpriteEl = document.getElementById("clip-sprite");
export const getCatEls = () => document.getElementsByClassName("cat");
export const getHeadEls = () => document.getElementsByClassName("head");
export const getBodyEls = () => document.getElementsByClassName("body");
export const textEls = document.getElementsByClassName("text");
export const explodeCanvasEl = document.getElementById("explode");

export const infoEl = document.getElementById("info");
export const infoBgEl = document.getElementById("info-bg");
export const infoTextEl = document.getElementById("info-text");
export const infoCloseBtnEl = document.getElementById("info-close");
export const infoArrowRightEl = document.getElementById("info-arrow-right");
export const infoArrowLeftEl = document.getElementById("info-arrow-left");
export const infoArrowBottomEl = document.getElementById("info-arrow-bottom");
export const infoArrowTopEl = document.getElementById("info-arrow-top");
export const closeIntroBtnEl = document.getElementById("close-intro");
export const introModalEl = document.getElementById("intro");
export const introTextEl = document.getElementById("intro-text");
export const mapEl = document.getElementById("map");

export const indicatorsBgEl = document.getElementById("indicators-bg");
export const indicatorsEl = document.getElementById("indicators");
export const gameIndicatorsEl = document.getElementById("game-indicators");
export const boostersEl = document.getElementById("boosters");

export const stepsEl = document.getElementById("steps");
export const timerEl = document.getElementById("timer");
export const livesEl = document.getElementById("lives");
export const livesHeartEl = document.getElementById("lives-heart");
export const livesCounterEl = document.getElementById("lives-counter");
export const barsEl = document.getElementsByClassName("bar");
export const menuUpgradeBtnEl = document.getElementById("menu-upgrade");
export const menuStoreEditorBtnEl =
  document.getElementById("menu-store-editor");
export const menuLogsBtnEl = document.getElementById("menu-logs");
export const menuTerminalBtnEl = document.getElementById("menu-terminal");
export const levelIndicatorEl = document.getElementById("level-indicator");
export const levelLivesIndicatorsEl = document.getElementById(
  "level-lives-indicators"
);
export const levelSeparatorEl = document.getElementById("level-separator");
export const menuLevelBtnEl = document.getElementById("menu-level");
// export const menuShareBtnEl = document.getElementById("menu-share");
export const menuRmAdsBtnEl = document.getElementById("menu-rm-ads");
export const menuInviteFriendBtnEl =
  document.getElementById("menu-invite-friend");
export const menuMainMenuBtnEl = document.getElementById("menu-main-menu");
export const menuCommunityBtnEl = document.getElementById("menu-community");
export const menuFeedbackBntEl = document.getElementById("menu-feedback");
export const menuAutoTranslateBtnEl = document.getElementById(
  "menu-auto-translate"
);
// export const menuOpenLeaderboardBtnEl = document.getElementById(
//   "menu-open-leaderboard"
// );
export const menuAchievementsBtnEl =
  document.getElementById("menu-achievements");
export const menuMapBtnEl = document.getElementById("menu-map");
export const menuMusicBtnEl = document.getElementById("menu-music");
export const menuDifficultyBtnEl = document.getElementById("menu-difficulty");
export const menuEarnBtnEl = document.getElementById("menu-earn");
export const scoreLandscapeEl = document.getElementById("landscape-score");
export const colorScoreEl = document.getElementById("color-score");
export const menuChangeColorBtnEl = document.getElementById("menu-color");
export const menuDividerEls = document.getElementsByClassName("menu-divider");
export const menuDividerNavEl = document.getElementById("menu-divider-nav");
export const menuProfilePhotoBtnEl =
  document.getElementById("menu-profile-photo");
export const menuProfilePhotoImgEl = document.getElementById(
  "menu-profile-photo-img"
);
export const menuProfilePhotoCaptionEl = document.getElementById(
  "menu-profile-photo-caption"
);
export const menuProfilePhotoIconEl = document.getElementById(
  "menu-profile-photo-icon"
);
export const menuProfilePhotoUnameEl = document.getElementById(
  "menu-profile-photo-uname"
);
export const levelLandscapeEl = document.getElementById(
  "landscape-level-indicator"
);
export const communityProfileFeedEl = document.getElementById(
  "community-profile-feed"
);

export const showTipBtnEl = document.getElementById("show-tip");

export const menuEl = document.getElementById("menu");
export const menuBgEl = document.getElementById("menu-bg");
export const menuOpenBtnEl = document.getElementById("menu-open");
export const menuCloseBtnEl = document.getElementById("menu-close");
export const menuShutdownBtnEl = document.getElementById("menu-shutdown");
export const menuVersionBtnEl = document.getElementById("menu-version");

export const pickLevelCloseBtnEl = document.getElementById("pick-level-close");
export const pickLevelEl = document.getElementById("pick-level");
export const pickLevelBgEl = document.getElementById("pick-level-bg");
export const pickLevelItemsEl = document.getElementById("pick-level-items");

export const previousEpisodeEl = document.getElementById("previous-episode");
export const nextEpisodeEl = document.getElementById("next-episode");
export const episodeTextEl = document.getElementById("episode-text");
export const episodesCtrlEl = document.getElementById("episodes-control");

export const noLivesEl = document.getElementById("no-lives");
export const noLivesCloseBtnEl = document.getElementById("no-lives-close");
export const noLivesElCta = document.getElementById("no-lives-cta");
export const noLivesElCtaRewardVideo = document.getElementById("no-lives-cta2");
export const noLivesElCtaInviteFriend =
  document.getElementById("no-lives-cta3");
export const noLivesElCtaContainer = document.getElementById(
  "no-lives-cta-container"
);

export const wonContainerEl = document.getElementById("won-container");
export const wonAnimationEl = document.getElementById("won-animation");
export const wonBannerEl = document.getElementById("won-banner");

export const subscribeEl = document.getElementById("subscribe");
export const subscribeTitleEl = document.getElementById("subscribe-title");
export const subscribeNowContainerEl = document.getElementById(
  "subscribe-now-container"
);
export const subscribeCloseBtnEl = document.getElementById("subscribe-close");
export const selectYearlyIconEl = document.getElementById("select-yearly-icon");
export const selectMonthlyIconEl = document.getElementById(
  "select-monthly-icon"
);
export const selectYearlyEl = document.getElementById("select-yearly");
export const selectMonthlyEl = document.getElementById("select-monthly");
export const subscriptionDiscountEl = document.getElementById(
  "subscription-discount"
);
export const subscribeNowBtnEl = document.getElementById("subscribe-now");
export const subscribeYearlyEl = document.getElementById("subscribe-yearly");
export const subscribeMonthlyEl = document.getElementById("subscribe-monthly");
export const subscribeYearlyMonthEl = document.getElementById(
  "subscribe-yearly-month"
);
export const subscribeMonthlyMonthEl = document.getElementById(
  "subscribe-monthly-month"
);
export const subscribePopularEl = document.getElementById("subscribe-popular");
export const subscribeSelectPlanEl = document.getElementById(
  "subscribe-select-a-plan"
);
export const subscribeUnlockLevelsDescriptionEl = document.getElementById(
  "subscribe-unlock-levels-description"
);
export const subscribeUnlockColorsDescriptionEl = document.getElementById(
  "subscribe-unlock-colors-description"
);
export const subscribeRmAdsDescriptionEl = document.getElementById(
  "subscribe-rm-ads-description"
);

export const exitGameDialogEl = document.getElementById("exit-game-dialog");
export const exitGameDialogTitleEl = document.getElementById(
  "exit-game-dialog-title"
);
export const exitGameDialogOkEl = document.getElementById(
  "exit-game-dialog-ok"
);
export const exitGameDialogCancelEl = document.getElementById(
  "exit-game-dialog-cancel"
);
export const exitGameDialogFeedbackEl = document.getElementById(
  "exit-game-dialog-feedback"
);
export const loseLifeDialogEl = document.getElementById("lose-life-dialog");
export const loseLifeDialogTitleEl = document.getElementById(
  "lose-life-dialog-title"
);
export const loseLifeDialogOkEl = document.getElementById(
  "lose-life-dialog-ok"
);
export const loseLifeDialogCancelEl = document.getElementById(
  "lose-life-dialog-cancel"
);

export const feedbackDialogEl = document.getElementById("feedback-dialog");
export const feedbackDialogTitleEl = document.getElementById(
  "feedback-dialog-title"
);
export const feedbackDialogOkEl = document.getElementById("feedback-dialog-ok");
export const feedbackDialogCancelEl = document.getElementById(
  "feedback-dialog-cancel"
);

export const replayDialogEl = document.getElementById("replay-dialog");
export const replayDialogTitleEl = document.getElementById(
  "replay-dialog-title"
);
export const replayDialogPreviewEl = document.getElementById(
  "replay-view-preview"
);
export const replayCommunityDialogPreviewEl = document.getElementById(
  "replay-community-view-preview"
);
export const replayDialogOkEls =
  document.getElementsByClassName("replay-dialog-ok");
export const replayDialogCancelEl = document.getElementById(
  "replay-dialog-cancel"
);
export const replaySpeedControlBtnEls = document.getElementsByClassName(
  "replay-view-speed-control"
);

export const endEpisodesEl = document.getElementById("end-episodes");
export const waitTimerEl = document.getElementById("wait-timer");

export const mainMenuEl = document.getElementById("main-menu");
export const playClassicBtnEl = document.getElementById("play-classic");
export const playQuestBtnEl = document.getElementById("play-quest");

export const spinnerEl = document.getElementById("spinner");
export const spinnerCaptionEl = document.getElementById("spinner-caption");

export const oneStarReviewBtnEl = document.getElementById("1-star-review");
export const twoStarReviewBtnEl = document.getElementById("2-star-review");
export const threeStarReviewBtnEl = document.getElementById("3-star-review");
export const fourStarReviewBtnEl = document.getElementById("4-star-review");
export const fiveStarReviewBtnEl = document.getElementById("5-star-review");
export const feedbackTextAreaEl = document.getElementById("feedback-text");
export const feedbackEmailInputEl = document.getElementById("feedback-email");
export const feedbackOkEl = document.getElementById("feedback-dialog-ok");
export const feedbackCancelEl = document.getElementById(
  "feedback-dialog-cancel"
);
export const feedbackThanksEl = document.getElementById(
  "feedback-thanks-dialog"
);
export const feedbackThanksOkEl = document.getElementById(
  "feedback-thanks-dialog-ok"
);
export const feedbackThanksCancelEl = document.getElementById(
  "feedback-thanks-dialog-cancel"
);
export const feedbackScrollContainerEl = document.getElementById(
  "feedback-scroll-container"
);

export const profileEditorDialogEl = document.getElementById(
  "profile-editor-dialog"
);
export const profileEditorDialogTitleEl = document.getElementById(
  "profile-editor-dialog-title"
);
export const profileEditorDialogOkEl = document.getElementById(
  "profile-editor-dialog-ok"
);
export const profileEditorDialogCancelEl = document.getElementById(
  "profile-editor-dialog-cancel"
);
export const profileEditorAboutMeTextAreaEl = document.getElementById(
  "profile-editor-about-me"
);
export const profileEditorEmailInputEl = document.getElementById(
  "profile-editor-email"
);
export const profileEditorOkEl = document.getElementById(
  "profile-editor-dialog-ok"
);
export const profileEditorCancelEl = document.getElementById(
  "profile-editor-dialog-cancel"
);
export const profileEditorScrollContainerEl = document.getElementById(
  "profile-editor-scroll-container"
);
export const profileEditorUnameEl = document.getElementById(
  "profile-editor-uname"
);
export const profileEditorNameEl = document.getElementById(
  "profile-editor-name"
);
export const profileEditorPhotoEl = document.getElementById(
  "profile-editor-photo"
);
export const profileEditorDatePickerBtnEl = document.getElementById(
  "profile-editor-date-picker"
);
export const profileEditorTiktokEl = document.getElementById(
  "profile-editor-tiktok"
);
export const profileEditorRedditEl = document.getElementById(
  "profile-editor-reddit"
);
export const profileEditorDiscordEl = document.getElementById(
  "profile-editor-discord"
);
export const profileEditorIgEl = document.getElementById("profile-editor-ig");

export const profileEl = document.getElementById("profile");
export const profileContainerEl = document.getElementById("profile-container");
export const profileAboutMeEl = document.getElementById("profile-about-me");
export const profileUnameEl = document.getElementById("profile-uname");
export const profileNameEl = document.getElementById("profile-name");
export const profileCountersEl = document.getElementById("profile-counters");
export const profileFollowersCounterEl = document.getElementById(
  "profile-followers-counter"
);
export const profileFollowingCounterEl = document.getElementById(
  "profile-following-counter"
);
export const profileStoryModeCounterEl = document.getElementById(
  "profile-story-mode-counter"
);
export const profileLevelsWonCounterEl = document.getElementById(
  "profile-levels-won-counter"
);
export const profileLevelsCreatedCounterEl = document.getElementById(
  "profile-levels-created-counter"
);

export const profilePhotoEl = document.getElementById("profile-photo");
export const profileBtnEl = document.getElementById("profile-button");
export const profileSocialEl = document.getElementById("profile-social");
export const profileBackBtnEl = document.getElementById("profile-back");
export const profileFeedEl = document.getElementById("profile-feed");

export const complimentAnimationEl = document.getElementById(
  "compliment-animation"
);
export const complimentImageEl = document.getElementById("compliment-image");

export const tellUsWhatYouThinkBtnEl = document.getElementById(
  "tell-us-what-you-think"
);

export const cellSelectorDialogEl = document.getElementById("cell-selector");
export const cellSelectorCatEl = document.getElementById("cell-selector-cat");
export const cellSelectorCatRmEl = document.getElementById(
  "cell-selector-cat-rm"
);
export const cellSelectorFreeEl = document.getElementById("cell-selector-free");
export const cellSelectorNonBlockableEl = document.getElementById(
  "cell-selector-non-blockable"
);
export const cellSelectorBlockedEl = document.getElementById(
  "cell-selector-blocked"
);
export const cellSelectorDropEl = document.getElementById("cell-selector-drop");
export const cellSelectorCenterEl = document.getElementById(
  "cell-selector-center"
);
export const cellSelectorShuffleEl = document.getElementById(
  "cell-selector-shuffle"
);
export const cellSelectorCatchEl = document.getElementById(
  "cell-selector-catch"
);
export const cellSelectorFreezeEl = document.getElementById(
  "cell-selector-freeze"
);
export const cellSelectorRmEl = document.getElementById("cell-selector-rm");
export const cellSelectorBackgroundEl =
  document.getElementById("cell-selector-bg");
export const editorPlayBtnEl = document.getElementById("editor-play");
export const editorPlayContainerEl = document.getElementById(
  "editor-play-container"
);
export const editorSaveBtnEl = document.getElementById("editor-save");
export const editorSaveContainerEl = document.getElementById(
  "editor-save-container"
);

export const editorPlayIconEl = document.getElementById("editor-play-icon");
export const editorZoomOutBtnEl = document.getElementById("editor-zoom-out");
export const editorZoomInBtnEl = document.getElementById("editor-zoom-in");
export const editorChangeShapeBtnEl = document.getElementById(
  "editor-change-shape"
);
export const editorSelectAllBtnEl =
  document.getElementById("editor-select-all");
export const editorSelectAllContainerEl = document.getElementById(
  "editor-select-all-container"
);
export const editorSelectAllDoneBtnEl = document.getElementById(
  "editor-select-all-done"
);
export const editorRestartBtnEl = document.getElementById("editor-restart");
export const editorShowLoosingFieldsBtnEl = document.getElementById(
  "editor-show-loosing-fields"
);
export const editorSelectAllDoneContainerEl = document.getElementById(
  "editor-select-all-done-container"
);
export const editorSelectPendingTasksBtnEl = document.getElementById(
  "editor-pending-tasks"
);
export const editorPendingTasksTextEl = document.getElementById(
  "editor-pending-tasks-text"
);
export const editorPendingTasksIconEl = document.getElementById(
  "editor-pending-tasks-icon"
);
export const editorPendingTasksBtnEl = document.getElementById(
  "editor-pending-tasks-btn"
);
export const editorBtnsEl = document.getElementById("editor-btns");
export const playLoginBtnEl = document.getElementById("play-login");
export const playCommunityBtnEl = document.getElementById("play-community");

export const communityFeedEl = document.getElementById("community-feed");
export const communityFabEl = document.getElementById("community-fab");
export const communityNavEl = document.getElementById("community-nav");
export const communityNavBtnEls = communityNavEl.querySelectorAll(".item");

export const publishLevelDialogEl = document.getElementById(
  "publish-level-dialog"
);
export const publishLevelDialogContainerEl = document.getElementById(
  "publish-level-dialog-container"
);
export const publishLevelDialogScrollContainerEl = document.getElementById(
  "publish-level-dialog-scroll-container"
);
export const publishLevelDialogScrollContainerContainerEl =
  document.getElementById("publish-level-dialog-scroll-container-container");
export const publishLevelDialogTitleEl = document.getElementById(
  "publish-level-dialog-title"
);
export const publishLevelAccessControlCaptionEl = document.getElementById(
  "publish-level-access-control-caption"
);
export const publishLevelAccessControlEl = document.getElementById(
  "publish-level-access-control"
);
export const publishLevelAccessControlLabelPrivateEl = document.getElementById(
  "publish-level-access-control-label-private"
);
export const publishLevelAccessControlRadioBtnEl = document.getElementById(
  "publish-level-access-control-radio-btn"
);
export const publishLevelAccessControlLabelPublicEl = document.getElementById(
  "publish-level-access-control-label-public"
);
export const publishLevelDescriptionCaptionEl = document.getElementById(
  "publish-level-description-caption"
);
export const publishLevelDescriptionEl = document.getElementById(
  "publish-level-description"
);
export const profileEditorAboutMeEl = document.getElementById(
  "profile-editor-about-me"
);
export const publishLevelDialogBtnsEl = document.getElementById(
  "publish-level-dialog-btns"
);
export const publishLevelDialogCancelEl = document.getElementById(
  "publish-level-dialog-cancel"
);
export const publishLevelDialogOkEl = document.getElementById(
  "publish-level-dialog-ok"
);
export const publishLevelDialogBgEl = document.getElementById(
  "publish-level-dialog-bg"
);
export const publishLevelDescriptionTextareaEl = document.getElementById(
  "publish-level-description-textarea"
);

export const replayOneStarReviewBtnEl = document.getElementById(
  "replay-1-star-review"
);
export const replayTwoStarReviewBtnEl = document.getElementById(
  "replay-2-star-review"
);
export const replayThreeStarReviewBtnEl = document.getElementById(
  "replay-3-star-review"
);
export const replayFourStarReviewBtnEl = document.getElementById(
  "replay-4-star-review"
);
export const replayFiveStarReviewBtnEl = document.getElementById(
  "replay-5-star-review"
);
export const replayFavIconEl = document.getElementById("replay-favorite-icon");
export const replayFavEl = document.getElementById("replay-favorite");
export const replayCommunityOkBtnEl = document.getElementById(
  "replay-dialog-community-ok"
);
export const replayCommunityCancelBtnEl = document.getElementById(
  "replay-dialog-community-cancel"
);
export const replayCommunityDialogEl = document.getElementById(
  "replay-dialog-community"
);

export const deleteLevelDialogEl = document.getElementById(
  "delete-level-dialog"
);
export const deleteLevelDialogCancelBtnEl = document.getElementById(
  "delete-level-dialog-cancel"
);
export const deleteLevelDialogDeleteBtnEl = document.getElementById(
  "delete-level-dialog-delete"
);

export const signInDialogEl = document.getElementById("signin-dialog");
export const signInDialogCancelBtnEl = document.getElementById(
  "signin-dialog-cancel"
);
export const signInDialogSignInBtnEl = document.getElementById(
  "signin-dialog-delete"
);

export const gameProfileEl = document.getElementById("game-profile");
export const gameProfileImgEl = document.getElementById("game-profile-img");
export const gameProfileUnameEl = document.getElementById("game-profile-uname");

export const noSignalIndicatorEl = document.getElementById(
  "no-signal-indicator"
);
export const noSignalIndicatorIconEl = document.getElementById("wifi-icon");
